import { render, staticRenderFns } from "./WameedMenu.vue?vue&type=template&id=6ac93ce8&"
import script from "./WameedMenu.vue?vue&type=script&lang=js&"
export * from "./WameedMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports